export default [
    {
      path: '/videolist',
      name: 'videolist',
      component: () => import('@/components/videoclass/videolist'),
    },
  
    {
        path:'/projectDetail',
        name:'projectDetail',
        component: () => import('@/page/project/projectDetail')
    },
    {
      path:'/projectUpload',
      name:'projectUpload',
      component: () => import('@/page/project/projectUpload')
  },
  ]